// extracted by mini-css-extract-plugin
export default {"container":"Title_container__9RC62","h1":"Title_h1__8LBMQ","h2":"Title_h2__f06vK"};